import { render, staticRenderFns } from "./AgentInBreak.vue?vue&type=template&id=4521aa97&scoped=true"
import script from "./AgentInBreak.vue?vue&type=script&lang=js"
export * from "./AgentInBreak.vue?vue&type=script&lang=js"
import style0 from "./AgentInBreak.vue?vue&type=style&index=0&id=4521aa97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521aa97",
  null
  
)

export default component.exports